import styled from "styled-components";

import { Routes, Route } from "react-router-dom";

import Homepage from "./Components/Homepage";
import PortfolioPage from "./Components/PortfolioPage";
// import ContactMe from './Components/ContactMe'
// import BlogPage from "./Components/BlogPage";

function App() {

  return (
    <AppContainer>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/portfoliopage" element={<PortfolioPage />} />
      </Routes>
    </AppContainer>
  );
}

const AppContainer = styled.div`
  font-family: "Inter";
  background-color: #E3F2FD;
`

export default App;
